import { createBEM as t } from "./bem.js";
import { createComponent as o } from "./component.js";
import { createI18N as e } from "./i18n.js";
function i(r) {
  return r = "van-" + r, [o(r), t(r), e(r)];
}
export { i as createNamespace };
